import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import Glow from '../../../../glows'
import LearnMoreButton from '../LearnMoreButton'
import AnimatedContainer from '../../../../ui/AnimatedContainer/animatedContainer'
// views
import {
  titleAnimation,
  subtitleAnimation,
} from '../../../../../constants/animation'
// assets
import { ReactComponent as ImplementationSceneDesktop } from '../../../../../assets/imgs/recruting/implementation.svg'
import { ReactComponent as ImplementationSceneMobile } from '../../../../../assets/imgs/recruting/implementation-mobile.svg'

const PodImplementationSection = () => (
  <section className='recruiting-content'>
    <div className='box'>
      <Glow position='left' />

      <AnimatedContainer className='recruiting-grid-container recruiting-implementation-grid'>
        <div className='recruiting-implementation-section-desktop'>
          <ImplementationSceneDesktop />
        </div>
        <div className='recruiting-implementation-section-mobile'>
          <ImplementationSceneMobile />
        </div>

        <div>
          <motion.p className='recruiting-main-title' variants={titleAnimation}>
            Turnkey Implementation
          </motion.p>
          <motion.p
            className='recruiting-sub-content-container'
            variants={subtitleAnimation}
          >
            There's no need to replace your existing ATS or technology, by
            placing Pod Recruiting next to your current workflow, you can
            instantly reduce the time to hire quality candidates.
          </motion.p>
          <div className='recruiting-button-container'>
            <LearnMoreButton />
          </div>
        </div>
      </AnimatedContainer>
    </div>
  </section>
)

export default PodImplementationSection
